import React, { useState, useEffect, useCallback } from "react";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function BranchUsers({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || 'null')?.admin ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token : null;
  const [users, setUsers] = useState([]);
  const [branchId, setBranchId] = useState();
  const [selectedUser, setSelectedUser] = useState(null);
  const [editFormData, setEditFormData] = useState({
    customer_name: "",
    contact_number: "",
    email: "",
    valid_id_number: "",
    role: "staff",
    city: "",
    address: "",
    status: 1,
    is_verified: 1,
  });
  const [passwordData, setPasswordData] = useState("");
  const navigate = useNavigate();

  const fetchUsers = useCallback(() => {
    try {
      axios
        .get(apiKey + "/get-branch-users", {
          params: { branch_id: branchId },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setUsers(res.data.result);
        })
        .catch((err) => {
          console.error(err);
          toast.error("Failed to fetch branch users");
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, token]);

  const handleChangeStatus = async (user) => {
    const newStatus = user.status === 1 ? 0 : 1;
    if (window.confirm(`Are you sure you want to ${newStatus === 1 ? 'activate' : 'deactivate'} this user?`)) {
      try {
        await axios.put(`${apiKey}/update-user-status/${user.id}/${newStatus}`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(`User ${newStatus === 1 ? 'activated' : 'deactivated'} successfully`);
        fetchUsers();
      } catch (err) {
        console.error(err);
        toast.error("Failed to update status");
      }
    }
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${apiKey}/update-branch-user/${selectedUser.id}`, editFormData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("User information updated successfully");
      document.getElementById("closeEditModalBtn").click();
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.Error || "Failed to update user");
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${apiKey}/update-branch-user-password/${selectedUser.id}`, { password: passwordData }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Password updated successfully");
      document.getElementById("closePasswordModalBtn").click();
      setPasswordData("");
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.Error || "Failed to update password");
    }
  };

  const columns = [
    {
      header: lang.Name || "Name",
      accessorKey: "customer_name",
    },
    {
      header: lang.Email || "Email",
      accessorKey: "email",
    },
    {
      header: lang.Phone_Number || "Phone Number",
      accessorKey: "contact_number",
    },
    {
      header: lang.Role || "Role",
      accessorKey: "role",
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) => (
        <span className={`badge rounded-pill ${row.getValue() === 1 ? 'bg-success' : 'bg-danger'}`}>
          {row.getValue() === 1 ? (lang.active || "Active") : (lang.inactive || "Inactive")}
        </span>
      ),
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id={`dropdownMenuButton-${row.row.original.id}`}
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${row.row.original.id}`}>
            <li>
              <button
                className="dropdown-item mt-0"
                data-bs-toggle="modal"
                data-bs-target="#editUserModal"
                onClick={() => {
                  setSelectedUser(row.row.original);
                  setEditFormData({
                    customer_name: row.row.original.customer_name,
                    contact_number: row.row.original.contact_number,
                    email: row.row.original.email,
                    valid_id_number: row.row.original.valid_id_number,
                    role: row.row.original.role,
                    city: row.row.original.city,
                    address: row.row.original.address,
                    status: row.row.original.status,
                    is_verified: row.row.original.is_verified,
                  });
                }}
              >
                {lang.Edit_Information || "Edit Information"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                data-bs-toggle="modal"
                data-bs-target="#changePasswordModal"
                onClick={() => {
                  setSelectedUser(row.row.original);
                  setPasswordData("");
                }}
              >
                {lang.Change_Password || "Change Password"}
              </button>
            </li>
            <li>
              <button
                className={`dropdown-item mt-0 ${row.row.original.status === 1 ? 'text-danger' : 'text-success'}`}
                onClick={() => handleChangeStatus(row.row.original)}
              >
                {row.row.original.status === 1 ? (lang.Deactivate || "Deactivate") : (lang.Activate || "Activate")}
              </button>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  const isLighMode =
    JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
    )?.light_mode === "yes";

  useEffect(() => {
    if (branchId) {
      fetchUsers();
    }
  }, [branchId, fetchUsers]);

  useEffect(() => {
    const admin = JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin);
    setBranchId(admin.branch_id);
  }, []);

  return (
    <main id="main" className="main">
      <ToastContainer position="bottom-right" autoClose={5000} />
      <div className="pagetitle">
        <h1>{lang.Branch_Users || "Branch Users"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Users || "Users"}</li>
            <li className="breadcrumb-item active">{lang.Branch_Users || "Branch Users"}</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                  <h5 className="card-title m-0">{lang.User_List || "User List"}</h5>
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate(!isLighMode ? "/dashboard/add-branch-user" : "/lightmode/dashboard/add-branch-user")}
                  >
                    + {lang.Add_User || "Add User"}
                  </button>
                </div>
                <div className="mt-3 mb-3">
                  <Table lang={lang} data={users} columns={columns} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Edit User Modal */}
      <div className="modal fade" id="editUserModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{lang.Edit_Information || "Edit Information"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeEditModalBtn" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleUpdateUser}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">{lang.Name || "Name"} *</label>
                    <input type="text" className="form-control" value={editFormData.customer_name || ""} onChange={(e) => setEditFormData({ ...editFormData, customer_name: e.target.value })} required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">{lang.Email || "Email"} *</label>
                    <input type="email" className="form-control" value={editFormData.email || ""} onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })} required />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">{lang.Phone_Number || "Phone Number"} *</label>
                    <input type="text" className="form-control" value={editFormData.contact_number || ""} onChange={(e) => setEditFormData({ ...editFormData, contact_number: e.target.value })} required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">{lang.Identity_Number || "Identity Number"} *</label>
                    <input type="text" className="form-control" value={editFormData.valid_id_number || ""} onChange={(e) => setEditFormData({ ...editFormData, valid_id_number: e.target.value })} required />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">{lang.Role || "Role"} *</label>
                    <select className="form-select" value={editFormData.role || "staff"} onChange={(e) => setEditFormData({ ...editFormData, role: e.target.value })} required>
                      <option value="staff">Staff</option>
                      <option value="manager">Manager</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                </div>
                <div className="text-end mt-4">
                  <button type="button" className="btn btn-secondary me-2" data-bs-dismiss="modal">{lang.Cancel || "Cancel"}</button>
                  <button type="submit" className="btn btn-primary">{lang.Update || "Update"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Change Password Modal */}
      <div className="modal fade" id="changePasswordModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{lang.Change_Password || "Change Password"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="closePasswordModalBtn" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleChangePassword}>
                <div className="mb-3">
                  <label className="form-label">{lang.New_Password || "New Password"} *</label>
                  <input type="password" className="form-control" value={passwordData} onChange={(e) => setPasswordData(e.target.value)} required minLength={6} />
                </div>
                <div className="text-end mt-4">
                  <button type="button" className="btn btn-secondary me-2" data-bs-dismiss="modal">{lang.Cancel || "Cancel"}</button>
                  <button type="submit" className="btn btn-primary">{lang.Update || "Update"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default BranchUsers;